import { initializeApp } from "firebase/app";

/*const firebaseConfig = {
    apiKey: "AIzaSyD_1Siq23Wq8mEXkLhkaxHiQIzB0pmxjHI",
    authDomain: "video-uploader-ae0a3.firebaseapp.com",
    projectId: "video-uploader-ae0a3",
    storageBucket: "video-uploader-ae0a3.appspot.com",
    messagingSenderId: "686177472728",
    appId: "1:686177472728:web:eebd9c5f4c00dc4fd7c7ad"
  };
  */
  const firebaseConfig = {
    apiKey: "AIzaSyBoHK6nNsMTtnuQhHTi0D8Qz4_lixuK2Ow",
    authDomain: "phacotrainer.firebaseapp.com",
    projectId: "phacotrainer",
    storageBucket: "phacotrainer.appspot.com",
    messagingSenderId: "212920436925",
    appId: "1:212920436925:web:5d15231666492461878fd4"
  };
  

export const app = initializeApp(firebaseConfig);